import { render, staticRenderFns } from "./RegionCardChart.vue?vue&type=template&id=08c82871"
import script from "./RegionCardChart.vue?vue&type=script&lang=js"
export * from "./RegionCardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports